module.exports = __webpack_public_path__ + "static/media/cover-lithium-batteries.57fb2f85.jpg";